import { LogIn } from 'lucide-react';
import { Link } from 'react-router';

import { StyledLink } from '@/components/styled-link';
import { Button } from '@/components/ui/button';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';

export const UnknownError = ({ heading }: { heading: string }) => {
  return (
    <AuthTemplate
      heading={heading}
      subheading={<UnknownErrorSubheading />}
      footer={<FooterLinks />}
    >
      <Button asChild>
        <Link to="/">
          <LogIn className="w-4 h-4 mr-2" />
          Continue to FlagSync
        </Link>
      </Button>
    </AuthTemplate>
  );
};

function UnknownErrorSubheading() {
  return (
    <div className="flex flex-col space-y-2">
      <span>
        Sorry about that! We are aware of the problem and are looking into it.
      </span>
      <span className="text-sm">
        Feel free to contact us at{' '}
        <StyledLink href="mailto:support@flagsync.com">
          support@flagsync.com
        </StyledLink>{' '}
        and we can take a look.
      </span>
    </div>
  );
}
